import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { isDemoTicketing } from 'store/ticketingPublic';
import { accessNested, isObject, displayWhen } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { Link } from 'components/core/link/link.js';
import PaymentLoader from 'components/shared/theaters/ticketing/gateways/paymentLoader';
import s from 'components/shared/theaters/ticketing/gateways/authnetPaymentGateway/authnetPaymentGateway.sss';


const AUTHNET_URL_DEV = 'https://test.authorize.net/payment/payment';
const AUTHNET_URL_PROD = 'https://accept.authorize.net/payment/payment';
const AUTHNET_URL = isDemoTicketing() ? AUTHNET_URL_DEV : AUTHNET_URL_PROD;

const AUTHNET_IFRAME_LOADING_TIME_MS = 2500;

const AuthnetLogo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 10 358 65" {...props}>
		<path d="M21.8,33.3H22l4.6,13h-9.3L21.8,33.3 M27.3,63.1h17.3v-2c-3.3-0.4-4.4-0.7-6.5-6.6c-2.4-6.4-5.2-13.9-7.8-21.4l-4.2-11.7L23,22.3L10.2,54.7c-2.2,5.7-3,6-6.8,6.4v2h14.2v-2L16.1,61c-2.9-0.3-3-1-2.1-4.2c0.8-2.7,1.6-5.5,2.4-7.3h11.2c1,2.3,2.2,5.6,3,7.7c1.1,2.7,0.7,3.4-1.6,3.8l-1.7,0.2V63.1z" />
		<path d="M62.7,41.2c0-2.3-0.3-2.7-1.9-3l-2-0.3v-1.8c3.2-0.2,8.7-0.8,11.6-1.2v21.4c0,2.6,0.3,3.3,2.3,3.3h2v2c-3.8,0.5-7.8,1.4-11.4,2.3l-0.5-0.4v-4c-1.2,0.9-2.3,1.7-3.6,2.5c-2,1.2-3.5,1.8-5.5,1.8c-5.3,0-8.2-3.5-8.2-8.3V41.2c0-2.3-0.3-2.7-1.9-3l-1.7-0.3v-1.8c2.9-0.2,8.1-0.8,11.4-1.2v19c0,3.7,1.9,5.2,4.3,5.2c1.8,0,3.5-0.8,5.4-2.4V41.2" />
		<path d="M86,53.8c0,4.8,2.4,5.7,3.5,5.7c1,0,2.1-0.3,3.3-1l0.9,1.9l-5.4,2.7c-1,0.5-1.9,0.7-2.4,0.7c-4.9,0-7.6-2.1-7.6-7.7V38.6h-4l-0.4-0.8l2-2.4h2.5v-3.9l6.6-5l1.1,0.5v8.3h6.2c0.8,0.7,0.7,2.7-0.4,3.2H86V53.8" />
		<path d="M106.4,38.7c2.1-2.1,5.3-4,8.6-4c5.7,0,8.9,3.6,8.9,9.5V57c0,3.5,0.3,3.8,3.8,4.2v2h-14.8v-2c3.1-0.4,3.3-0.7,3.3-4.2V44.9c0-3.9-2.2-5.6-4.8-5.6c-1.7,0-3.6,0.6-5,2.1V57c0,3.5,0.3,3.8,2.9,4.2v2H94.1v-2c4.2-0.4,4.5-0.7,4.5-4.2V26.5c0-3.7-0.1-3.8-4.1-4.1v-1.8c2.8-0.4,7.7-1.3,11.8-2.2V38.7" />
		<path d="M137.5,47.4c0-6.8,2.7-10.2,5.3-10.2c4,0,6.5,4.9,6.5,13.3c0,9.1-2.8,10.7-5.1,10.7C140,61.2,137.5,55.3,137.5,47.4 M143.7,34.6c-7.1,0-14.9,5.3-14.9,15.3c0,6.8,4.9,13.9,14.6,13.9c7.3,0,14.5-4.9,14.5-15.2C157.9,41.3,152.5,34.6,143.7,34.6z" />
		<path d="M171.4,57c0,3.5,0.3,3.8,5.2,4.2v2h-17.2v-2c4-0.4,4.3-0.7,4.3-4.2V43c0-3.9-0.1-3.9-4.2-4.4v-1.7c3.7-0.5,7.7-1.4,11.9-2.3v6.3h0.1c0.8-1.3,1.8-2.8,3-4c1.2-1.3,2.6-2.2,4.2-2.2c2.4,0,4.2,1.8,4.2,3.9c0,2.1-1.4,3.9-3,4.5c-0.8,0.3-1.4,0.1-1.9-0.3c-1.1-0.9-2.1-1.3-3.2-1.3c-1.1,0-2.3,0.5-3.4,3.1V57" />
		<path d="M187.9,43c0-3.9-0.1-3.9-4.2-4.4v-1.7c3.7-0.5,7.9-1.4,11.9-2.3v22.3c0,3.6,0.3,3.9,4.3,4.3v2h-16.4v-2c4-0.4,4.3-0.7,4.3-4.3V43 M195.8,24.7c0,2.6-2,4.6-4.6,4.6c-2.5,0-4.6-2-4.6-4.6c0-2.6,2.1-4.6,4.6-4.6C193.8,20.1,195.8,22.1,195.8,24.7z" />
		<path d="M225.1,35.4l0.6,0.9l-14.5,24.2h5c4.3,0,6-0.8,8.2-4.4l0.9-1.6l2.3,0.8c-1.1,3.1-1.9,5.5-2.9,7.8h-22.8l-0.6-0.9l15-24.2h-4.4c-4.2,0-5.3,1-6.7,4.1L204,44l-2.3-0.8c0.7-2.4,1.7-6.4,2.3-9.2h1.4c0.3,0.9,1,1.3,3.4,1.3H225.1" />
		<path d="M234.7,45.1c0.4-4.3,2.7-7.6,5-7.6c2.4,0,4.4,3.3,4.4,5.9c0,1.2-0.2,1.5-1.2,1.5L234.7,45.1 M250.4,55.8c-2.5,1.7-4.5,2.4-6.8,2.4c-4.8,0-9.1-3.3-9.1-10.3c6.3-0.2,14.7-0.8,15.6-1c1.3-0.2,1.4-0.4,1.4-2.8c0-4.9-4.4-9.5-9.8-9.5c-7.7,0-14.5,6.8-14.5,15.9c0,7.1,4.9,13.3,13.4,13.3c2.2,0,7.1-1.3,10.7-6.8L250.4,55.8z" />
		<path d="M253.5,58.9c0-2.8,2.1-4.9,4.8-4.9c2.8,0,4.8,2.1,4.8,4.9c0,3-2.1,4.9-4.8,4.9C255.6,63.9,253.5,61.9,253.5,58.9" />
		<path d="M303.9,63.6H300l-25.1-30.8h-0.1v13.1c0,6.6,0.4,10.1,0.6,12.1c0.3,2.2,1.9,3,6.1,3.2v2h-15.7v-2c3.2-0.1,4.7-1,5-3.2c0.3-2,0.7-5.5,0.7-12.1V33.3c0-4,0-5.6-1.1-7.1c-1.2-1.5-2.8-1.9-5.4-2.1v-2h11l24.4,28.4h0.1V39.4c0-6.6-0.4-10.1-0.6-12.1c-0.3-2.2-1.9-3-6.1-3.2v-2h15.7v2c-3.2,0.1-4.7,1-5,3.2c-0.3,2-0.6,5.5-0.6,12.1V63.6" />
		<path d="M313.6,45.1c0.4-4.3,2.7-7.6,5-7.6c2.4,0,4.4,3.3,4.4,5.9c0,1.2-0.2,1.5-1.2,1.5L313.6,45.1 M329.3,55.8c-2.5,1.7-4.5,2.4-6.9,2.4c-4.8,0-9.1-3.3-9.1-10.3c6.2-0.2,14.7-0.8,15.5-1c1.3-0.2,1.4-0.4,1.4-2.8c0-4.9-4.3-9.5-9.8-9.5c-7.7,0-14.5,6.8-14.5,15.9c0,7.1,4.9,13.3,13.4,13.3c2.2,0,7.2-1.3,10.7-6.8L329.3,55.8z" />
		<path d="M342.6,53.8c0,4.8,2.4,5.7,3.5,5.7c1,0,2.1-0.3,3.3-1l0.9,1.9l-5.4,2.7c-1,0.5-1.9,0.7-2.4,0.7c-4.8,0-7.6-2.1-7.6-7.7V38.6h-4l-0.4-0.8l2-2.4h2.4v-3.9l6.7-5l1.1,0.5v8.3h6.2c0.8,0.7,0.7,2.7-0.4,3.2h-5.8V53.8" />
		<path d="M350.2,33.1c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.3-0.9-0.7-1.2-1.2c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.7-0.9,1.2-1.2c0.5-0.3,1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.6,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.2,1.1-0.4,1.6c-0.3,0.5-0.7,0.9-1.2,1.2C351.2,32.9,350.7,33.1,350.2,33.1 M350.2,32.6c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.6,1-1c0.2-0.4,0.4-0.9,0.4-1.4c0-0.5-0.1-0.9-0.4-1.3c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.9-0.4-1.4-0.4c-0.5,0-0.9,0.1-1.3,0.4c-0.4,0.2-0.8,0.6-1,1c-0.2,0.4-0.4,0.9-0.4,1.3c0,0.5,0.1,0.9,0.4,1.4c0.3,0.4,0.6,0.7,1,1C349.2,32.5,349.7,32.6,350.2,32.6z M349.6,31.8h-0.6v-3.8h1.2c0.3,0,0.5,0,0.7,0.1c0.1,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.4-0.6,0.5c0.1,0.1,0.3,0.3,0.4,0.6l0.6,1.1h-0.7l-0.5-0.9l-0.1-0.2c-0.1-0.3-0.2-0.4-0.3-0.4h-0.5V31.8z M349.6,29.7h0.4c0.3,0,0.5-0.1,0.6-0.2c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.5-0.1h-0.5V29.7z" />
	</svg>
);


export default class AuthnetPaymentGateway extends Component {

	constructor(props) {
		super(props);

		this.$iframe = null;
		this.scrolled = false;

		this.state = {
			loading: true
		};

		this.checkIframeLocation = this.checkIframeLocation.bind(this);
	}

	componentDidMount() {
		this.$form.submit();
		this.timer = setInterval(this.checkIframeLocation, 500);

		const that = this;
		setTimeout(() => that.setState({ loading: false }), AUTHNET_IFRAME_LOADING_TIME_MS);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	componentWillReceiveProps() {
		// Just a scoll down trick to make sure the user sees the "Pay" button
		// const iframeHeight = accessNested(newProps, 'ticketing.iframeSize.height');
		if (this.props.client.isIOS && !this.scrolled && !this.state.loading) {
			this.scrolled = true;
			const that = this;
			setTimeout(() => that.$container.parentElement.scrollTop = 130, 100);
		}
	}

	/**
	 * Handle the "Cancel" button of the Authorize.net iframe.
	 * Note that we could have used another thundr base to handle this.
	 */
	checkIframeLocation() {
		try {
			if (this.$iframe.contentWindow.location.href === window.location.href) {
				// Location has changed, so the user has pressed cancel
				// Go back to the previous step
				Store.emit(actions.GO_TICKETING_REVIEW);
			}
		} catch (err) {
			// console.error('Error:', err);
		}
	}

	render(props, { loading }) {
		const {
			ticketing, // Object - the ticketing state
			theater,   // Object - the active theater
			client     // Object - the client information object
		} = props;

		const theaterName = accessNested(ticketing, 'meta.theaterName');
		const iframeHeight = 509;

		const { paymentData } = ticketing;
		const token = isObject(paymentData) ? paymentData.token : paymentData;

		return (
			<div class={s.container} ref={$ref => this.$container = $ref}>
				<header class={s.header}>
					<h2 class={s.title}>{getCopy('PROVIDE_PAYMENT_INFO', { THEATER_NAME: theaterName })}</h2>
				</header>
				<div class={s.iframeWrapper}>
					<div style={displayWhen(!loading)}>
						<iframe
							class={s.iframe}
							name="authnetIframe"
							scrolling="yes"
							ref={$ref => this.$iframe = $ref}
						/>
					</div>
					<PaymentLoader color="#2f5571" style={displayWhen(loading)}>
						<AuthnetLogo />
					</PaymentLoader>
					<form class={s.tmpForm} method="POST" action={AUTHNET_URL} target="authnetIframe" ref={ref => this.$form = ref}>
						<input type="hidden" name="token" value={token} />
					</form>
				</div>
				<footer class={s.footer}>
					<p>
						<svg class={s.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
							<path d="M50.164 13.896c-12.817 0-23.292 10.446-23.342 23.252v6.956h-1.029a4.283 4.283 0 0 0-4.293 4.294v33.414a4.283 4.283 0 0 0 4.293 4.292h48.414a4.283 4.283 0 0 0 4.293-4.292V48.398a4.283 4.283 0 0 0-4.293-4.294h-.703v-6.956c-.05-12.806-10.523-23.252-23.34-23.252zm0 7.5c8.763 0 15.789 7 15.838 15.752v6.956H34.324v-6.956a15.785 15.785 0 0 1 15.84-15.752zM50 54.426a6.045 6.045 0 0 1 6.045 6.046 6.045 6.045 0 0 1-3.945 5.664l.9 7.152h-6l.9-7.154a6.045 6.045 0 0 1-3.945-5.662A6.045 6.045 0 0 1 50 54.427z" />
						</svg>
						<span class={s.encryption}>SSL Encryption</span>
						<span>powered by</span>
						<Link class={s.authnetLogo} target="_blank" href="https://www.authorize.net/" renderCustomChild>
							<AuthnetLogo />
						</Link>
					</p>
				</footer>
			</div>
		);
	}

}
